import React, {useEffect, useState} from "react";
import {shallowEqual, useDispatch, useSelector} from "react-redux";
import PropTypes from "prop-types";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faEngineWarning, faQrcode} from "@fortawesome/pro-regular-svg-icons";
import {Drawer, IconButton, Typography,} from "@material-ui/core";

import {useStyles} from "./EntityProvisionButton.style";
import {useTheme} from "@material-ui/core/styles";
import clsx from "clsx";
import WarningIcon from '@material-ui/icons/Warning';
import {FindEntity} from "../../../state/slices/entities";
import {useConfirmationDialog} from "../../../hooks/useConfirmationDialog";
import EntityQRCode from "./EntityQRCode";
import {useCoreEntityContext} from "../../../hooks/useCoreEntitySlice";
import {clearEntityState, selectEntityById} from "../../../state/slices/CoreEntity";
import {selectOrgTreeEntityById} from "../../../state/slices/OrgTree";
import apiClient from "../../../auth/apiClient";
import DeviceService from "../../../services/DeviceService";

const EntityProvisionButton = ({entityID, isBeingListened, ...props}) => {
    const theme = useTheme();
    const dispatch = useDispatch();

    const useCoreEntitySlice = useCoreEntityContext();
    const classes = useStyles();
    const entity = useSelector((state) => {
        let _entity = useCoreEntitySlice ? selectEntityById(state, entityID) : FindEntity(state.entities?.EntityList ?? [], entityID);
        if (useCoreEntitySlice && !_entity?.entityid) {
            _entity = selectOrgTreeEntityById(state, entityID);
        }
        return _entity
    }, shallowEqual);
    const {textConfirmation} = useConfirmationDialog();
    const deviceService = new DeviceService(apiClient); // Create DeviceService instance

    const [drawerState, setDrawerState] = useState(false);

    async function SuperSureConfirmation() {
        let confirmMessage = (
            <>
                <WarningIcon
                    className={clsx(["animate__animated", "animate__tada"])}
                    style={{
                        color: theme.palette.warning.main,
                        float: "left",
                        alignItems: "baseline",
                        marginRight: 15,
                        height: "2em",
                        width: "2em",
                    }}
                ></WarningIcon>
                <Typography
                    variant="subtitle1"
                    style={{color: theme.palette.warning.main}}
                >
                    This Device is currently online and already provisioned. Are you sure?
                </Typography>
            </>
        );

        return await textConfirmation({
            title: `${entity.name.toUpperCase()} is Online.`,
            message: confirmMessage,
            textConfirmation: entity.name.toUpperCase(),
            buttons: [
                {name: "Yes", color: "secondary"},
                {name: "Cancel", color: theme.palette.text.disabled},
            ],
        });
    }

    async function ProvisionDeviceConfirmation() {
        let provisionMessage = (
            <>
                <FontAwesomeIcon
                    className={clsx(["animate__animated", "animate__tada"])}
                    icon={faEngineWarning}
                    size="4x"
                    style={{
                        color: theme.palette.error.main,
                        float: "left",
                        alignItems: "baseline",
                        marginRight: 15,
                    }}
                ></FontAwesomeIcon>
                <Typography
                    variant="subtitle1"
                    style={{color: theme.palette.error.main}}
                >
                    This will reset the device security key and secret. A working device
                    will need to be reprovisioned if you continue.
                </Typography>
            </>
        );

        const confirmed = await textConfirmation({
            title: `PROVISION ${entity.name.toUpperCase()}?`,
            message: provisionMessage,
            textConfirmation: entity.name.toUpperCase(),
            buttons: [
                {name: "Yes", color: "secondary"},
                {name: "Cancel", color: theme.palette.text.disabled},
            ],
        });

        // if (confirmed && entity.state !== null) {
        //     try {
        //         const response = await deviceService.reprovisionDevice(entity.entityid);
        //         if (response?.status !== 200) {
        //             console.error("Error reprovisioning device: Unexpected status", response?.status);
        //             return false;
        //         }
        //     } catch (error) {
        //         console.error("Error reprovisioning device:", error);
        //         return false;
        //     }
        // }

        return confirmed
    }

    async function handleProvisionClick() {
        if (entity.state !== null) {
            if (await SuperSureConfirmation()) {
                if (await ProvisionDeviceConfirmation()) {
                    //await dispatch(clearEntityState({entityId :entity.entityid}));
                    setDrawerState(true);
                }
            }
        } else {
            if (await ProvisionDeviceConfirmation()) {
                setDrawerState(true);
            }
        }
    }

    useEffect(() => {
        //if user or entity changes
    }, [entity.state]);
    return (
        <>
            <IconButton
                {...props}
                title={`Provision ${entity.name}`}
                aria-label={`Provision ${entity.name}`}
                disabled={!isBeingListened}
                onClick={async (e) => {
                    e.stopPropagation();
                    e.preventDefault();
                    await handleProvisionClick()
                }}
            >
                <FontAwesomeIcon icon={faQrcode} size="1x"/>
            </IconButton>
            <Drawer
                classes={{paper: classes.drawerPaper}}
                open={drawerState}
                anchor="top"
            >
                <Typography style={{padding: 20}}>
                    <EntityQRCode
                        entityID={entity.entityid}
                        onClose={() => setDrawerState(false)}
                    ></EntityQRCode>
                </Typography>
            </Drawer>
        </>
    );
};

EntityProvisionButton.defaultProps = {entityID: null, isBeingListened: true};
EntityProvisionButton.propTypes = {entityID: PropTypes.string, isBeingListened: PropTypes.bool};

export default EntityProvisionButton;
